jQuery(function ($) {

    Shopify.Cart.ShippingCalculator.show( {
        submitButton: "Calcular",
        submitButtonDisabled: "Calculando...",
        moneyFormat: moneyformat
    });

    function inputHandler(masks, max, event) {
        var c = event.target;
        var v = c.value.replace(/\D/g, "");
        var m = c.value.length > max ? 1 : 0;
        VMasker(c).unMask();
        VMasker(c).maskPattern(masks[m]);
        c.value = VMasker.toPattern(v, masks[m]);
    }

    // ------------------------------------------------------------------
    // CORREÇÃO (Iter): antes, quando o carrinho estava vazio, este script
    // adicionava o produto de verdade ao carrinho (Shopify.addItem) só pra
    // calcular o frete, e removia 10s depois (Shopify.removeItem). Isso
    // gerava eventos reais de "adicionar ao carrinho" no Meta/GA4 sem o
    // cliente ter feito nada.
    //
    // Agora, quando o carrinho está vazio, calculamos o frete usando a
    // Storefront API com um carrinho isolado e descartável — nunca toca
    // no carrinho real do cliente, então nenhum evento de rastreamento é
    // disparado. Quando o carrinho já tem itens, mantemos o comportamento
    // antigo (que já era correto, pois usa o carrinho real de verdade).
    // ------------------------------------------------------------------

    var STOREFRONT_ACCESS_TOKEN = "0caef7a069a6b80fe489c05dffd9e020";
    var STOREFRONT_API_VERSION = "2024-10";

    function renderRatesFromStorefront(rates, shippingAddress) {
        // Monta a mesma estrutura de "response" que a biblioteca antiga
        // (jquery.cart.min.js / Shopify.Cart.ShippingCalculator) usa para
        // desenhar o resultado no template #shipping-calculator-response-template.
        var readable_address = "";
        if (shippingAddress.zip) readable_address += shippingAddress.zip + ", ";
        if (shippingAddress.province) readable_address += shippingAddress.province + ", ";
        readable_address += "Brasil";

        var formattedRates = rates.map(function (r) {
            var priceStr = Shopify.formatMoney(Math.round(parseFloat(r.estimatedCost.amount) * 100), moneyformat);
            if (parseFloat(r.estimatedCost.amount) === 0) priceStr = "Grátis";
            return {
                price: priceStr,
                title: r.title,
                name: r.title
            };
        });

        if (formattedRates.length) {
            var freeEl = $("#estimated-shipping em");
            if (parseFloat(rates[0].estimatedCost.amount) === 0) {
                freeEl.html("Grátis");
            } else {
                freeEl.html(formattedRates[0].price);
            }
        }

        var template = $("#shipping-calculator-response-template");
        var wrapper = $("#wrapper-response");
        wrapper.empty();
        if (template.length && wrapper.length) {
            var myTemplate = _.template($.trim(template.text()));
            var compiled = myTemplate({
                rates: formattedRates,
                address: readable_address,
                success: true
            });
            $(compiled).appendTo(wrapper);
        }
        $("#wrapper-response, #estimated-shipping").fadeIn();
        $(".get-rates-custom").removeClass("loading");
        $(".get-rates-custom").attr("value", "Calcular");
    }

    function renderStorefrontError(message) {
        console.error("[Calculadora de frete] erro na Storefront API:", message);
        $("#estimated-shipping").hide();
        $(".get-rates-custom").removeClass("loading");
        $(".get-rates-custom").attr("value", "Calcular");
        alert("Não foi possível calcular o frete no momento. Tente novamente em instantes.");
    }

    function getRatesViaStorefrontApi(variantNumericId, shippingAddress) {
        var merchandiseId = "gid://shopify/ProductVariant/" + variantNumericId;
        var query =
            "mutation cartCreate($input: CartInput!) {" +
            "  cartCreate(input: $input) {" +
            "    cart {" +
            "      id" +
            "      deliveryGroups(first: 5) {" +
            "        edges { node { deliveryOptions { handle title estimatedCost { amount currencyCode } } } }" +
            "      }" +
            "    }" +
            "    userErrors { field message }" +
            "  }" +
            "}";

        var variables = {
            input: {
                lines: [{ merchandiseId: merchandiseId, quantity: 1 }],
                buyerIdentity: {
                    countryCode: "BR",
                    deliveryAddressPreferences: [{
                        deliveryAddress: {
                            address1: "N/A",
                            city: "N/A",
                            province: shippingAddress.province,
                            zip: shippingAddress.zip,
                            country: "Brazil"
                        }
                    }]
                }
            }
        };

        fetch("/api/" + STOREFRONT_API_VERSION + "/graphql.json", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN
            },
            body: JSON.stringify({ query: query, variables: variables })
        })
        .then(function (res) { return res.json(); })
        .then(function (json) {
            console.log("[Calculadora de frete][DEBUG] resposta da Storefront API:", json);
            if (json.errors) {
                renderStorefrontError(JSON.stringify(json.errors));
                return;
            }
            var payload = json.data && json.data.cartCreate;
            if (!payload || (payload.userErrors && payload.userErrors.length)) {
                renderStorefrontError(payload ? JSON.stringify(payload.userErrors) : "resposta vazia");
                return;
            }
            var edges = payload.cart.deliveryGroups.edges;
            if (!edges.length || !edges[0].node.deliveryOptions.length) {
                renderStorefrontError("nenhuma opção de frete retornada para este CEP");
                return;
            }
            renderRatesFromStorefront(edges[0].node.deliveryOptions, shippingAddress);
        })
        .catch(function (err) {
            console.error("[Calculadora de frete][DEBUG] erro completo:", err);
            renderStorefrontError((err && err.stack) || (err && err.message) || String(err));
        });
    }

    var carregaFrete = function(cep) {
        if($("#address_zip").val().length != 9) {
            alert("Digite um cep válido")
        }else{
            var flag = true;
            $(".get-rates-custom").addClass("loading");
            $("#shipping-calculator2 .loading").addClass("load");
            $(".get-rates-custom").attr('value', 'Calculando...');

            $.getJSON("//viacep.com.br/ws/" + cep + "/json/?callback=?", function(dados) {
                if (!("erro" in dados)) {
                    if(!$("#shipping-calculator2.shiping-loaded")[0]) {

                        $("#shipping-calculator2").addClass("shiping-loaded")
                    }
                    var state;
                    var uf = dados.uf.toUpperCase();
                    switch (uf) {
                        case "AC" :	state = "Acre";					break;
                        case "AL" :	state = "Alagoas";				break;
                        case "AM" :	state = "Amazonas";				break;
                        case "AP" :	state = "Amapá";				break;
                        case "BA" :	state = "Bahia";				break;
                        case "CE" :	state = "Ceará";				break;
                        case "DF" :	state = "Distrito Federal";		break;
                        case "ES" :	state = "Espírito Santo";		break;
                        case "GO" :	state = "Goiás";				break;
                        case "MA" :	state = "Maranhão";				break;
                        case "MG" :	state = "Minas Gerais";			break;
                        case "MS" :	state = "Mato Grosso do Sul";	break;
                        case "MT" :	state = "Mato Grosso";			break;
                        case "PA" :	state = "Pará";					break;
                        case "PB" :	state = "Paraíba";				break;
                        case "PE" :	state = "Pernambuco";			break;
                        case "PI" :	state = "Piauí";				break;
                        case "PR" :	state = "Paraná";				break;
                        case "RJ" :	state = "Rio de Janeiro";		break;
                        case "RN" :	state = "Rio Grande do Norte";	break;
                        case "RO" :	state = "Rondônia";				break;
                        case "RR" :	state = "Roraima";				break;
                        case "RS" :	state = "Rio Grande do Sul";	break;
                        case "SC" :	state = "Santa Catarina";		break;
                        case "SE" :	state = "Sergipe";				break;
                        case "SP" :	state = "São Paulo";			break;
                        case "TO" :	state = "Tocantíns";			break;
                      }
                    $('[name="address[province]"] option[value="' + state + '"]').prop('selected', true);
                    $('.get-rates').trigger('click');
                } else {
                    flag = false;
                    alert("CEP não encontrado");
                }
                $(".get-rates-custom").removeClass("loading");
                $(".get-rates-custom").attr('value', 'Calcular');

            }).fail(function(jqXHR) {
                alert("Consulta de CEP indisponivel no momento")
            });
        }
    }

    $(document).on('keypress', '#address_zip', function(event) {
        if(event.keyCode == 13) {
            event.preventDefault();
            $(".get-rates-custom").trigger("click")
        }
    });
    $(document).on('click', '.get-rates-custom', function() {
        var variantid = $("#variantid");
        if(variantid[0]) {
            var variantvalue = $("#variantid").val();
            var cartItens;

            jQuery.getJSON('/cart.js', function(cart) {
                cartItens = cart.item_count;
                if(cartItens == 0) {
                    // CORREÇÃO: em vez de adicionar/remover do carrinho real,
                    // calcula via Storefront API num carrinho descartável.
                    carregaFreteViaStorefront(variantvalue);
                }else {
                    console.log(cartItens + " - itens no carrinho")
                    carregaFrete($('#address_zip').val());
                }
            });
        }else {
            carregaFrete($('#address_zip').val());
        }
    });

    function carregaFreteViaStorefront(variantvalue) {
        if($("#address_zip").val().length != 9) {
            alert("Digite um cep válido");
            return;
        }
        $(".get-rates-custom").addClass("loading");
        $(".get-rates-custom").attr('value', 'Calculando...');

        $.getJSON("//viacep.com.br/ws/" + $("#address_zip").val() + "/json/?callback=?", function(dados) {
            if ("erro" in dados) {
                alert("CEP não encontrado");
                $(".get-rates-custom").removeClass("loading");
                $(".get-rates-custom").attr('value', 'Calcular');
                return;
            }
            var state;
            var uf = dados.uf.toUpperCase();
            switch (uf) {
                case "AC" :	state = "Acre";					break;
                case "AL" :	state = "Alagoas";				break;
                case "AM" :	state = "Amazonas";				break;
                case "AP" :	state = "Amapá";				break;
                case "BA" :	state = "Bahia";				break;
                case "CE" :	state = "Ceará";				break;
                case "DF" :	state = "Distrito Federal";		break;
                case "ES" :	state = "Espírito Santo";		break;
                case "GO" :	state = "Goiás";				break;
                case "MA" :	state = "Maranhão";				break;
                case "MG" :	state = "Minas Gerais";			break;
                case "MS" :	state = "Mato Grosso do Sul";	break;
                case "MT" :	state = "Mato Grosso";			break;
                case "PA" :	state = "Pará";					break;
                case "PB" :	state = "Paraíba";				break;
                case "PE" :	state = "Pernambuco";			break;
                case "PI" :	state = "Piauí";				break;
                case "PR" :	state = "Paraná";				break;
                case "RJ" :	state = "Rio de Janeiro";		break;
                case "RN" :	state = "Rio Grande do Norte";	break;
                case "RO" :	state = "Rondônia";				break;
                case "RR" :	state = "Roraima";				break;
                case "RS" :	state = "Rio Grande do Sul";	break;
                case "SC" :	state = "Santa Catarina";		break;
                case "SE" :	state = "Sergipe";				break;
                case "SP" :	state = "São Paulo";			break;
                case "TO" :	state = "Tocantíns";			break;
            }
            getRatesViaStorefrontApi(variantvalue, {
                zip: $("#address_zip").val(),
                province: state
            });
        }).fail(function() {
            alert("Consulta de CEP indisponivel no momento");
            $(".get-rates-custom").removeClass("loading");
            $(".get-rates-custom").attr('value', 'Calcular');
        });
    }
});
